import React from 'react';
import PropTypes from 'prop-types';
import TextEditor from './TextEditor';
import useStoryContext from '../../hooks/useStoryContext';

export default function BodyTextEditor({ storyId, historyMode, readOnlyMode }) {
  const { contents } = useStoryContext();
  const body = contents.find(c => c.format === 'rich');

  return (
    <React.Fragment>
      {body && (
        <TextEditor
          storyId={storyId}
          contentEditorId={body.uuid}
          contentId={parseInt(body.id, 10)}
          historyMode={historyMode}
          readOnlyMode={readOnlyMode}
          format="rich"
        />
      )}
    </React.Fragment>
  );
}

BodyTextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

BodyTextEditor.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/BodyTextEditor.jsx